// 🔐 Login — delega en la pantalla de la MARCA de la instalación (VITE_BRAND).
// K2E: escena «Arc Reactor» (LoginK2E). TrackConstruction: Blueprint & Steel (LoginTrack).
import { marca } from '@brand';

export function Login() {
  const Vista = marca.LoginView;
  return <Vista />;
}
